import React from "react";
import { useNavigate } from "react-router-dom";
import "./error.css";
import Nav from "../components/layout/nav";

const ErrorPage = () => {
  const navigate = useNavigate();

  return (
    <div className="hcontainer errorpage ">
      <div className="homeee">

      <div className="errorOverlay">

        <h6 className="errorop">Egypt Fashion Week</h6>

        <h5 className="c404">404</h5>

        <h2 className="etitle">PAGE NOT FOUND</h2>

        <p className="errordesc">
          This page doesn't exist or has been moved.
        </p>

        <div className="errorbuttons">

          <button
            className="errorbtn"
            onClick={() => navigate(-1)}
          >
            Go Back
          </button>

          <button
            className="errorbtn solid"
            onClick={() => navigate("/")}
          >
            Home
          </button>

        </div>

      </div>
      <Nav />
      </div>
    </div>
  );
};

export default ErrorPage;